import React from 'react';

interface TypeformTransitionProps {
  children: React.ReactNode;
  direction: 'forward' | 'backward';
  currentKey: string;
}

export const TypeformTransition: React.FC<TypeformTransitionProps> = ({
  children,
  direction,
  currentKey,
}) => {
  return (
    <div
      key={currentKey}
      className={direction === 'forward' ? 'animate-typeform-up' : 'animate-typeform-down'}
    >
      {children}
    </div>
  );
};
